module.exports = __webpack_public_path__ + "static/media/HomePageBanner.f4ceddc5.jpg";